import Vue from 'vue';
import Vuex from 'vuex';

// Modules
import app from './app';
import appConfig from './app-config';
import verticalMenu from './vertical-menu';
import i18n from './i18n';
import masterData from './masterData';
import attachFile from './attachFile';
import tabView from './tabView';
import notify from './notify';
import bkNote from './bk-note';
import masterDataNoLogin from './masterDataNoLogin';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    i18n,
    masterData,
    attachFile,
    tabView,
    notify,
    bkNote,
    masterDataNoLogin
  },
  strict: process.env.DEV,
});
